/**
 * @generated SignedSource<<905c3b5a419e2f0736c147178c35bd69>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckIsStyleArticle$data = {
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "helpersCheckIsStyleArticle";
};
export type helpersCheckIsStyleArticle$key = {
  readonly " $data"?: helpersCheckIsStyleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsStyleArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckIsStyleArticle"
};

(node as any).hash = "67ab4ed74adc967c60838bed2eea211f";

export default node;
